import { createSelector } from '@reduxjs/toolkit';
import { ISelectOption } from 'shared/types/filters';
import { TApplicationState } from 'shared/types/redux';

export const selectSpecialtyTypeOptionsRaw = (state: TApplicationState) => state.specialtyTypeOptions;

export const selectSpecialtyTypesOptions = createSelector(selectSpecialtyTypeOptionsRaw, (items): ISelectOption[] =>
  items.map(item => ({ label: item.name, value: item.id })),
);
